import { HeadlineContainerType } from '@/payload-custom-types';
import clsx from 'clsx';

const HeadlineContainer = ({ children, inlineComponent = true, alignment = 'left'}: HeadlineType) => {
  const alignmentClass = `alignment-${alignment}`;
  const inlineComponentClass = inlineComponent ? 'inline-component' : 'standalone';

  return (
    <div className={clsx('headline-element-container', {[alignmentClass]: alignment}, [inlineComponentClass])}>
      {children}
    </div>
  );
};
HeadlineContainer.displayName = 'HeadlineContainer';

const Headline = ({ as: Tag = 'h1', children, className, tagStyle = Tag }: HeadlineType) => {
  if (Tag === null) {
    Tag = 'h2';
    tagStyle = 'h2';
  };

  return (
    <Tag className={clsx(`headline-style-${tagStyle}`, className)}>
      {children}
    </Tag>
  );
};
Headline.displayName = 'Headline';

const Subline = ({ children, className }: HeadlineType) => {
  return (
    <p className={clsx('subline', className)}>
      {children}
    </p>
  )
};
Subline.displayName = 'Subline';

const Roofline = ({ children, className }: HeadlineType) => {
  return (
    <p className={clsx('roofline', className)}>
      {children}
    </p>
  )
};
Roofline.displayName = 'Roofline';

const isHeadlineContainerFilled = (headlineContainer: HeadlineContainerType['headlineContainer']) => {
  return headlineContainer?.roofline || headlineContainer?.heading || headlineContainer?.subline;
};

export { HeadlineContainer, Headline, Subline, Roofline, isHeadlineContainerFilled };

//
// Example usage:
// <HeadlineContainer>
//   <Roofline>Roofline</Roofline>
//   <Headline as="h2">Headline</Headline>
//   <Subline>Subline</Subline>
// </HeadlineContainer>
//

//
// Types
// --------------------------------------------------------

interface HeadlineType {
  children: React.ReactNode;
  className?: string;
  inlineComponent?: boolean;
  alignment?: string;
  tagStyle?: React.ElementType | string | null;
  as?: React.ElementType | string | null;
};